import { render, staticRenderFns } from "./DossierCnpj.vue?vue&type=template&id=7cc22a9c&scoped=true&"
import script from "./DossierCnpj.vue?vue&type=script&lang=js&"
export * from "./DossierCnpj.vue?vue&type=script&lang=js&"
import style0 from "./DossierCnpj.vue?vue&type=style&index=0&id=7cc22a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc22a9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
